export default __webpack_public_path__ + "a8973a1.png";